'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M448 704l393.636 140.488 182.364-797.356zM320 659.908l704-612.776-1024 506.462zM448 771.954v252.046l185.752-185.752z' })
    ));
};